// Keeps the Shopify customer login fresh. Shopify's login token lasts about an hour; the refresh
// token saved at sign-in gets a new one. One renewal runs at a time for the whole page (shared with
// the theme's window.ohmaEnsureLogin), so two renewals never race with the same refresh token.
const HEROKU = 'https://customizer-test-nodejs-4c6a5bfd6dbd.herokuapp.com'
const RENEW_WITHIN_MS = 10 * 60 * 1000

const get = (k) => {
  try {
    return localStorage.getItem(k)
  } catch (e) {
    return null
  }
}
const set = (k, v) => {
  try {
    localStorage.setItem(k, v)
  } catch (e) {}
}
const del = (k) => {
  try {
    localStorage.removeItem(k)
  } catch (e) {}
}

// Resolves true when there is a usable login afterwards.
export function ensureFreshLogin() {
  if (typeof window !== 'undefined' && typeof window.ohmaEnsureLogin === 'function') {
    return Promise.resolve(window.ohmaEnsureLogin()).then((ok) => {
      if (ok) window.SHOPIFY_CUSTOMER_TOKEN = get('ohma_ctoken') || window.SHOPIFY_CUSTOMER_TOKEN
      return !!ok
    })
  }
  const token = get('ohma_ctoken')
  const exp = parseInt(get('ohma_ctoken_exp') || '0', 10)
  const refresh = get('ohma_ctoken_refresh')
  if (token && (!exp || exp - Date.now() > RENEW_WITHIN_MS)) return Promise.resolve(true)
  if (!refresh) return Promise.resolve(!!token && exp > Date.now())
  if (window.__ohmaRenewing) return window.__ohmaRenewing
  window.__ohmaRenewing = fetch(`${HEROKU}/api/auth/refresh`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh_token: refresh })
  })
    .then(async (r) => {
      if (r.status === 401) {
        // The refresh token itself has expired: sign out, unless something else already renewed it
        if (get('ohma_ctoken_refresh') === refresh) {
          del('ohma_ctoken')
          del('ohma_ctoken_exp')
          del('ohma_ctoken_refresh')
          window.SHOPIFY_CUSTOMER_TOKEN = null
        }
        return !!get('ohma_ctoken')
      }
      if (!r.ok) return !!token && exp > Date.now()
      const d = await r.json()
      if (!d || !d.access_token) return !!token && exp > Date.now()
      set('ohma_ctoken', d.access_token)
      set('ohma_ctoken_exp', String(d.exp || Date.now() + 3600000))
      if (d.refresh_token) set('ohma_ctoken_refresh', d.refresh_token)
      window.SHOPIFY_CUSTOMER_TOKEN = d.access_token
      try {
        window.dispatchEvent(new Event('ohma_login_renewed'))
      } catch (e) {}
      return true
    })
    .catch(() => !!token && exp > Date.now()) // network trouble: keep what we have, try again later
    .then((ok) => {
      window.__ohmaRenewing = null
      return ok
    })
  return window.__ohmaRenewing
}

// The current token if it is still valid, else null (does not renew; call ensureFreshLogin first).
export function currentToken() {
  const exp = parseInt(get('ohma_ctoken_exp') || '0', 10)
  if (exp && Date.now() > exp) return null
  return get('ohma_ctoken') || null
}
